import { Component } from 'react';
import { FormGroup, Input as BootstrapInput, Label } from 'reactstrap';

import './input-radio.css';

class InputRadio extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || '',
      checkedRadio: null,
    };
  }

  changeRadio(e) {
    this.setState({ checkedRadio: e.target.value });
  }

  render() {
    const fieldId = this.props.id ? this.props.id : this.props.name;
    return (
      <FormGroup className="m-1">
        <Label className="font-weight-bold mb-0" for={fieldId}>
          {this.props.label}
        </Label>
        <BootstrapInput
          {...this.props}
          value={this.props.value}
          onClick={(e) => {
            const value = e.target.value;
            this.setState({ value });

            this.props.onClick(value);
          }}
          type={this.props.type}
          name={this.props.name}
          id={fieldId}
          placeholder={this.props.placeholder}
        />
        <Label className="mb-0" for={fieldId}>
          {this.props.rlabel}
        </Label>
      </FormGroup>
    );
  }
}

export default InputRadio;
